export const SEARCH_THE_LIBRARY = "SEARCH_THE_LIBRARY";
export const VIEW_EVENT = "VIEW_EVENT";
export const VIEW_HELP = "VIEW_HELP";
export const PAGE_VIEW = "PAGE_VIEW";
export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const DOWNLOAD_LINK = "DOWNLOAD_LINK";
export const DOWNLOAD_DATA_DICTIONARY = "DOWNLOAD_DATA_DICTIONARY";
export const NAVIGATE_TO_EXTERNAL_RESOURCE = "NAVIGATE_TO_EXTERNAL_RESOURCE";

export const EVENT_ERROR = "EVENT_ERROR";
